import React from 'react';
import { FieldValues } from 'react-hook-form';
import FormRegion from '../../primitives/form-region';
import FormFieldset from '../../primitives/form-fieldset';
import StyledButton from '../../primitives/styled-button';
import Select, { SelectOption } from '../../primitives/select';
import FormProvider from '../../primitives/form-provider';
import { usStates, canadianProvinces } from '../../../constants/states';
import RowSet from '../../primitives/grid/row-set';

interface CeFormProps {
    submitButton?: string
}

const CeForm = ({ submitButton }: CeFormProps): JSX.Element => {
    const allStates = usStates.concat(canadianProvinces)
    const handleFormSubmit = async ({ state }: FieldValues): Promise<void> => {
        if (state && typeof state === 'string') {
            window.open(
                `https://ce.servpro.com/Home/ContinutingEducation?id=${state as string}`,
            );
        }
    };

    return (
        <FormProvider
            onSubmit={handleFormSubmit}
        >
            <RowSet breakpoints={{
                dt: { between: 16 },
            }}
            >
                <div css={{
                    maxWidth: '360px',
                    paddingTop: '12px',
                }}
                >
                    <Select
                        name="state"
                        placeholder="Select a State"
                        autoComplete="address-level1"
                        required
                    >
                        {allStates.map(item => (
                            <SelectOption value={item.abbreviation}>
                                {item.name}
                            </SelectOption>
                        ))}
                    </Select>
                </div>
                <StyledButton type="submit">
                    {submitButton || 'Submit'}
                </StyledButton>
            </RowSet>
        </FormProvider>
    );
};

export default CeForm;
